import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";

export const useImportPlanReviewViewModel = () => {
  const [planDetails, setPlanDetails] = useState({});
  const [areaTypes, setAreaTypes] = useState([]);

  const stateManager = useComponentState();

  const addIsRequiredToMaterials = (planData, areaTypesData) => {
    const updatedPlanData = { ...planData };

    const areaTypeLookup = {};
    areaTypesData.forEach((areaType) => {
      areaTypeLookup[areaType.id] = areaType;
    });

    // update materials with isRequired and referenceId
    if (updatedPlanData.planAreas) {
      updatedPlanData.planAreas = updatedPlanData.planAreas.map((area) => {
        const areaType = areaTypeLookup[area.areaTypeId];

        return {
          ...area,
          materials:
            area.materials
              ?.filter((material) => !material.linkedCategoryId) // filter lined materials
              .map((material) => {
                const category = areaType?.categories?.find(
                  (cat) => cat.categoryId === material.categoryId
                );

                return {
                  ...material,
                  isRequired: category?.isRequired || false,
                  referenceId: material.referenceId || createUUID(),
                };
              }) || [],
        };
      });
    }

    return updatedPlanData;
  };

  const getPlanDetails = (id) => {
    stateManager.run(async () => {
      const response = await homeService.plans.getById({ id });
      if (response.status === HTTP_STATUSES.OK) {
        const areaTypesData = await getAreaTypes();
        const planDetailsWithIsRequired = addIsRequiredToMaterials(
          response.data,
          areaTypesData
        );
        setAreaTypes(areaTypesData);
        setPlanDetails(planDetailsWithIsRequired);
      }
    });
  };

  const getAreaTypes = async () => {
    return stateManager.run(async () => {
      const response = await homeService.areaTypes.getAll({ sort: "name" });
      if (response.status === HTTP_STATUSES.OK) {
        return response.data;
      }
      return [];
    });
  };

  const handleUpdateCurrentStep = (planId, currentStep) => {
    stateManager.run(async () => {
      const response = await homeService.plans.importPlanCurrentStep({
        id: planId,
        data: { currentStep },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setPlanDetails((prev) => ({ ...prev, currentStep }));
      }
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    getPlanDetails,
    planDetails,
    areaTypes,
    stateManager,
    setPlanDetails,
    handleUpdateCurrentStep,
  };
};
